import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { productsFiles } from "../../Components/MedProducts/productFile";
import { saveDCREntry } from "../../api/dcrService";
import styles from "./DCR.module.css";

const GENERAL_SPECIALITY = "General";

const doctorsData = [
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Neru Goyal" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Archana" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Jostana" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Aliya" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Neha" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Ranjana" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Saloni" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Shristi" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Manisha" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Nidhi" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Ragini Ranjan" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Onjin" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Gunjan" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Sonam" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Anjali Gupta" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Poonam" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Shadiya" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Susri sangita" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Amrita A.P" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Shiwangi" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Siwani" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Archana AP" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Rafat" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Monika" },
  { city: "Patna", area: "Rajabazar (IGIMS)", speciality: "Gyne", name: "Dr. Shakshi" },

  { city: "Patna", area: "Phulwari Sharif", speciality: "Ortho", name: "Dr. Sameer Rahman" },
  { city: "Patna", area: "Phulwari Sharif", speciality: "Phy", name: "Dr. Kashif Rahman" },
  { city: "Patna", area: "Phulwari Sharif", speciality: "Phy", name: "Dr. Arshad Ahmad" },
  { city: "Patna", area: "Phulwari Sharif", speciality: "Ent", name: "Dr. Shaheen Zafar" },
  { city: "Patna", area: "Phulwari Sharif", speciality: "Phy", name: "Dr. Farid Alam" },
  { city: "Patna", area: "Phulwari Sharif", speciality: GENERAL_SPECIALITY, name: "Dr. Sidharth Singh" },
  { city: "Patna", area: "Phulwari Sharif", speciality: GENERAL_SPECIALITY, name: "Dr. Sarits Singh" },
  { city: "Patna", area: "Phulwari Sharif", speciality: GENERAL_SPECIALITY, name: "Dr. Hena Taiyab" },
  { city: "Patna", area: "Phulwari Sharif", speciality: GENERAL_SPECIALITY, name: "Dr. S A Khan" },

  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Nashib Iqbal Kamali" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Amit Kumar Sinha" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Marukh Nandan" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Sarika Ray" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Rajeev Ranjan" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Anita Singh" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Sudhir Kumar" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Anwar Alam" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Khusboo Kumari" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Kumar Anuj" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Abhishek Kumar" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Ranjan Kumar" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Sonu Kumar" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. S N Trivedi" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Saroj Singh" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. B B Bharti" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Meena Samanth" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. P C Verma" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Shipra Ray" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Sanju Jain" },
  { city: "Patna", area: "Kankarbag", speciality: GENERAL_SPECIALITY, name: "Dr. Uday Kumar" },

  { city: "Patna", area: "Rajendar Nagar", speciality: GENERAL_SPECIALITY, name: "Dr. Manish Kumar Bhaskar" },
  { city: "Patna", area: "Rajendar Nagar", speciality: GENERAL_SPECIALITY, name: "Dr. Nitish Kumar" },
  { city: "Patna", area: "Rajendar Nagar", speciality: GENERAL_SPECIALITY, name: "Dr. Usha Didwaniya" },
  { city: "Patna", area: "Rajendar Nagar", speciality: GENERAL_SPECIALITY, name: "Dr. Rajendar Pasad" },
  { city: "Patna", area: "Rajendar Nagar", speciality: GENERAL_SPECIALITY, name: "Dr. Manju Gita Mishra" },
  { city: "Patna", area: "Rajendar Nagar", speciality: GENERAL_SPECIALITY, name: "Dr. Pragya Mishra Choudhroi" },
  { city: "Patna", area: "Rajendar Nagar", speciality: GENERAL_SPECIALITY, name: "Dr. S R Vinod" },

  { city: "Patna", area: "Patna City", speciality: GENERAL_SPECIALITY, name: "Dr. V B Golwara" },
  { city: "Patna", area: "Patna City", speciality: GENERAL_SPECIALITY, name: "Dr. Valya Agarwal" },
  { city: "Patna", area: "Patna City", speciality: GENERAL_SPECIALITY, name: "Dr. H L Sahu" },
  { city: "Patna", area: "Patna City", speciality: GENERAL_SPECIALITY, name: "Dr. Sangita Kumari" },
  { city: "Patna", area: "Patna City", speciality: GENERAL_SPECIALITY, name: "Dr. Rajendar Parsad" },
  { city: "Patna", area: "Patna City", speciality: GENERAL_SPECIALITY, name: "Dr. S A Krishna" },

  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. Shipra Singh" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. B K Choudhri" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. Santosh" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. U S Roy" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. S K Banarje" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. Hema Charan" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. Rajeev Ranjan" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. Raveendar Kumar Sinha" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. Ajeet Kumar Sinha" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. S M Rahtogi" },
  { city: "Patna", area: "Boring Road", speciality: GENERAL_SPECIALITY, name: "Dr. Kushal Vikram" },

  { city: "Patna", area: "Patliputra", speciality: GENERAL_SPECIALITY, name: "Dr. N P Narayan" },

  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Ishrat Hussain" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. K.Ahtesham" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ent", name: "Dr. Md Sadab" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gp", name: "Dr. Asif Hussain" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Rubina Nazli" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Kafeel Ahmad" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ped", name: "Dr. A.K.Azad" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Nagma Aman" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ped", name: "Dr. Pradeep Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Arshi Nawab" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Masroor Alam" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Derma", name: "Dr. Manjoor Alam" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Dent", name: "Dr. Md Rasid" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ped", name: "Dr. Dinesh ku Singh" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Abhay Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Mamta Singh" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Surg", name: "Dr. Vinay Singh" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Rasid Ibrahim" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Bhanu Pratap Singh" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Reyajuddin Ahmad" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Pallavi" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Gayatri Thakur" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ped", name: "Dr. S.P.Pandey" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ped", name: "Dr. Umesh Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Surg", name: "Dr. Babar Ali" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Md Ali Khan" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Zeba Perveen" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Surg", name: "Dr. Md Mujamil" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Vandana kumari" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Firoj Alam" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Prakash Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ped", name: "Dr. Pankaj Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Narender Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Asutosh Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Asutosh Dinendra" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ent", name: "Dr. Pradeep Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Sweta Rani" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. REP.Gupta" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Surg", name: "Dr. Sanjay Prasad" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. S.Hussain" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Rakesh Gupta" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ped", name: "Dr. Manjit Ranjan" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Monali B Powar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Sandeep Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Azad Alam" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Shambhu Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Gyn", name: "Dr. Preet Mala" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Vishal Chaudhary" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Arbind Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ped", name: "Dr. Dilip Kumar" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Ortho", name: "Dr. Vivek Kumar" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Phy", name: "Dr. Sanjiv kumar" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Ortho", name: "Dr. Barun Kumar" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Gyn", name: "Dr. Sweta singh" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Ortho", name: "Dr. Subhash Singh" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Gp", name: "Dr. O.P.Singh" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Ped", name: "Dr. Yubraj Singh" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Gp", name: "Dr. Nazir Hussain" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Ortho", name: "Dr. Abdul Rahman" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Gyn", name: "Dr. Sunil Kumar" },
  { city: "Siwan", area: "Raghunathpur", speciality: "Gp", name: "Dr. Umesh Kumar Sharma" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Ped", name: "Dr. S.B.Prasad" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Gyn", name: "Dr. Abhilasha Singh" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Ped", name: "Dr. B.Kumar" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Ped", name: "Dr. Zahir Abass" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Gyn", name: "Dr. R.Tabasum" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Phy", name: "Dr. R.Kumar" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Phy", name: "Dr. Deepak Kumar" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Ent", name: "Dr. Abhishek Kumar" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Phy", name: "Dr. G.B.Khan" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Gyn", name: "Dr. Dazy Sinha" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Surg", name: "Dr. Manoj kumar Gupta" },
  { city: "Gopalganj", area: "Gopalganj", speciality: "Phy", name: "Dr. Md Jasimuddin" },
  { city: "Siwan", area: "Siwan HQ", speciality: "Phy", name: "Dr. Rahmat Ali" },
  { city: "Siwan", area: "Pachrukhi", speciality: "Gp", name: "Dr. Azahar Mumtaz" },
  { city: "Siwan", area: "Pachrukhi", speciality: "Gp", name: "Dr. A.K.Rai" },
  { city: "Siwan", area: "Pachrukhi", speciality: "Ped", name: "Dr. D.N.Gupta" },
  { city: "Siwan", area: "Duraundha", speciality: "Gp", name: "Dr. R.S.Prasad" },
  { city: "Siwan", area: "Maharajganj", speciality: "Gp", name: "Dr. Fuleshwar Kumar" },
  { city: "Siwan", area: "Maharajganj", speciality: "Gp", name: "Dr. L.B Rai" },
  { city: "Siwan", area: "Maharajganj", speciality: "Gp", name: "Dr. Deepak Yadav" },
  { city: "Siwan", area: "Maharajganj", speciality: "Gyn", name: "Dr. Bindu devi" },
  { city: "Siwan", area: "Pachrukhi", speciality: "Gp", name: "Dr. Sivnath Prasad" },
  { city: "Siwan", area: "Mairwa", speciality: "Ortho", name: "Dr. Jai Prakash" },
  { city: "Siwan", area: "Mairwa", speciality: "Phy", name: "Dr. Pawan ku Rai" },
  { city: "Siwan", area: "Mairwa", speciality: "Gp", name: "Dr. Nagendra Singh" },
  { city: "Siwan", area: "Mairwa", speciality: "Gp", name: "Dr. Anup Kumar" },
  { city: "Siwan", area: "Mairwa", speciality: "Gyn", name: "Dr. A.K.Yada" },
  { city: "Siwan", area: "Mairwa", speciality: "Ent", name: "Dr. Khursid Alam" },
  { city: "Siwan", area: "Mairwa", speciality: "Gyn", name: "Dr. preeti kumari" },
  { city: "Siwan", area: "Mairwa", speciality: "Ped", name: "Dr. Vishal gupta" },
  { city: "Siwan", area: "Mairwa", speciality: "Ped", name: "Dr. Amrit Kumar" },
  { city: "Siwan", area: "Mairwa", speciality: "Ped", name: "Dr. Anup Kumar" },
  { city: "Siwan", area: "Done", speciality: "Ped", name: "Dr. Ram Lal Chauhan" },
  { city: "Siwan", area: "Badhariya", speciality: "Gp", name: "Dr. Dharma Singh" },
  { city: "Siwan", area: "Badhariya", speciality: "Ped", name: "Dr. Arbind Yadav" },
  { city: "Siwan", area: "Badhariya", speciality: "Gp", name: "Dr. A.K.Aman" },
  { city: "Siwan", area: "Badhariya", speciality: "Phy", name: "Dr. R.K.Singh" },
  { city: "Siwan", area: "Badhariya", speciality: "Ped", name: "Dr. Md Seraj" },
  { city: "Siwan", area: "Badhariya", speciality: "Phy", name: "Dr. Imamuddin Haider" },
  { city: "Siwan", area: "Badhariya", speciality: "Phy", name: "Dr. Asraf Ali" },
  { city: "Siwan", area: "Badhariya", speciality: "Dent", name: "Dr. N.Ahmad" },
  { city: "Siwan", area: "Badhariya", speciality: "Ped", name: "Dr. Guddu Yadav" },
];

const getLocalDateString = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
};

const getInitialForm = () => {
  const date = getLocalDateString();
  const time = getInitialTime();
  return {
    city: "",
    area: "",
    speciality: "",
    doctor: "",
    product: [],
    visitType: "",
    date,
    time,
    status: "",
    notes: "",
  };
};

const visitTypes = ["Single Visit", "Group Visit", "Camp Activity", "Telephonic", "Follow-up"];

const statuses = ["Completed", "Pending", "Rescheduled", "Cancelled"];

const hours = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
const minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));
const periods = ["AM", "PM"];

function parseTime(value24) {
  if (!value24) return { hour: "12", minute: "00", period: "AM" };
  const [h24, m] = value24.split(":").map(Number);
  const period = h24 >= 12 ? "PM" : "AM";
  const h12 = h24 % 12 || 12;
  return { hour: String(h12).padStart(2, "0"), minute: String(m).padStart(2, "0"), period };
}

function buildTime(hour12, minute, period) {
  let h = parseInt(hour12, 10);
  if (period === "AM") {
    if (h === 12) h = 0;
  } else {
    if (h !== 12) h += 12;
  }
  return `${String(h).padStart(2, "0")}:${minute}`;
}

function getInitialTime() {
  const now = new Date();
  const h = now.getHours();
  const m = now.getMinutes();
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export default function DCR() {
  const { user } = useSelector((state) => state.auth);
  const [form, setForm] = useState(getInitialForm);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const cities = useMemo(() => [...new Set(doctorsData.map((d) => d.city))].sort(), []);

  const areas = useMemo(() => {
    if (!form.city) return [];
    return [...new Set(doctorsData.filter((d) => d.city === form.city).map((d) => d.area))].sort();
  }, [form.city]);

  const specialities = useMemo(() => {
    if (!form.city || !form.area) return [];
    return [...new Set(doctorsData.filter((d) => d.city === form.city && d.area === form.area).map((d) => d.speciality))].sort();
  }, [form.city, form.area]);

  const doctors = useMemo(() => {
    if (!form.city || !form.area || !form.speciality) return [];
    return doctorsData
      .filter((d) => d.city === form.city && d.area === form.area && d.speciality === form.speciality)
      .map((d) => d.name)
      .sort();
  }, [form.city, form.area, form.speciality]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      const next = { ...prev, [name]: value };
      if (name === "city") {
        next.area = "";
        next.speciality = "";
        next.doctor = "";
        next.product = [];
      } else if (name === "area") {
        next.speciality = "";
        next.doctor = "";
        next.product = [];
      } else if (name === "speciality") {
        next.doctor = "";
        next.product = [];
      } else if (name === "doctor") {
        next.product = [];
      }
      return next;
    });
    setError("");
  };

  const handleProductToggle = (productName) => {
    setForm((prev) => {
      const selected = new Set(prev.product);
      if (selected.has(productName)) {
        selected.delete(productName);
      } else {
        selected.add(productName);
      }
      return { ...prev, product: Array.from(selected) };
    });
    setError("");
  };

  const handleTimeChange = (field, value) => {
    setForm((prev) => {
      const current = parseTime(prev.time);
      const next = { ...current, [field]: value };
      return { ...prev, time: buildTime(next.hour, next.minute, next.period) };
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    if (!form.product || form.product.length === 0) {
      setError("Please select at least one product promoted.");
      return;
    }

    if (form.date > getLocalDateString()) {
      setError("You cannot select a future date.");
      return;
    }

    setLoading(true);

    try {
      const entry = {
        ...form,
        submittedBy: user?.email || "unknown",
        submittedByUid: user?.uid || "",
        submittedAt: new Date().toISOString(),
        createdAt: Date.now(),
      };

      await saveDCREntry(user.uid, entry);

      setSuccess("DCR entry saved successfully.");
      setForm(getInitialForm());
    } catch (err) {
      setError(err?.message || "Failed to save DCR entry. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.header}>
          <h1>DCR - Daily Call Report</h1>
          <p>Record your daily doctor visits and promotional details.</p>
        </div>

        {success && <div className={styles.alertSuccess}>{success}</div>}
        {error && <div className={styles.alertError}>{error}</div>}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.grid}>
            <div className={styles.field}>
              <label htmlFor="city">City</label>
              <select id="city" name="city" value={form.city} onChange={handleChange} required>
                <option value="">Select City</option>
                {cities.map((city) => (
                  <option key={city} value={city}>
                    {city}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.field}>
              <label htmlFor="area">Area</label>
              <select id="area" name="area" value={form.area} onChange={handleChange} required disabled={!form.city}>
                <option value="">{form.city ? "Select Area" : "Select City first"}</option>
                {areas.map((area) => (
                  <option key={area} value={area}>
                    {area}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.field}>
              <label htmlFor="speciality">Speciality</label>
              <select
                id="speciality"
                name="speciality"
                value={form.speciality}
                onChange={handleChange}
                required
                disabled={!form.area}
              >
                <option value="">{form.area ? "Select Speciality" : "Select Area first"}</option>
                {specialities.map((speciality) => (
                  <option key={speciality} value={speciality}>
                    {speciality}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.field}>
              <label htmlFor="doctor">Doctor</label>
              <select
                id="doctor"
                name="doctor"
                value={form.doctor}
                onChange={handleChange}
                required
                disabled={!form.speciality}
              >
                <option value="">{form.speciality ? "Select Doctor" : "Select Speciality first"}</option>
                {doctors.map((doctor) => (
                  <option key={doctor} value={doctor}>
                    {doctor}
                  </option>
                ))}
              </select>
            </div>

            <div className={`${styles.field} ${styles.productField}`}>
              <label>
                Product Promoted{" "}
                <span className={styles.selectedCount}>({form.product.length} selected)</span>
              </label>
              <div className={`${styles.productList} ${!form.doctor ? styles.productListDisabled : ""}`}>
                {!form.doctor && (
                  <div className={styles.productDisabledMessage}>Select Doctor first</div>
                )}
                {productsFiles.map((product) => (
                  <label key={product.id} className={styles.productOption}>
                    <input
                      type="checkbox"
                      disabled={!form.doctor}
                      checked={form.product.includes(product.name)}
                      onChange={() => handleProductToggle(product.name)}
                    />
                    <span>{product.name}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className={styles.field}>
              <label htmlFor="visitType">Visit Type</label>
              <select
                id="visitType"
                name="visitType"
                value={form.visitType}
                onChange={handleChange}
                required
                disabled={form.product.length === 0}
              >
                <option value="">{form.product.length > 0 ? "Select Visit Type" : "Select Product first"}</option>
                {visitTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.field}>
              <label htmlFor="date">Date</label>
              <input
                id="date"
                name="date"
                type="date"
                value={form.date}
                max={getLocalDateString()}
                onChange={handleChange}
                required
                disabled={!form.visitType}
              />
            </div>

            <div className={`${styles.field} ${styles.timeField}`}>
              <label>Time</label>
              <div className={styles.timeSelectors}>
                <select
                  value={parseTime(form.time).hour}
                  onChange={(e) => handleTimeChange("hour", e.target.value)}
                  disabled={!form.date}
                  required
                  aria-label="Hour"
                >
                  {hours.map((h) => (
                    <option key={h} value={h}>
                      {h}
                    </option>
                  ))}
                </select>
                <span className={styles.timeSeparator}>:</span>
                <select
                  value={parseTime(form.time).minute}
                  onChange={(e) => handleTimeChange("minute", e.target.value)}
                  disabled={!form.date}
                  required
                  aria-label="Minute"
                >
                  {minutes.map((m) => (
                    <option key={m} value={m}>
                      {m}
                    </option>
                  ))}
                </select>
                <select
                  value={parseTime(form.time).period}
                  onChange={(e) => handleTimeChange("period", e.target.value)}
                  disabled={!form.date}
                  required
                  aria-label="AM or PM"
                >
                  {periods.map((p) => (
                    <option key={p} value={p}>
                      {p}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className={styles.field}>
              <label htmlFor="status">Status</label>
              <select
                id="status"
                name="status"
                value={form.status}
                onChange={handleChange}
                required
                disabled={!form.time}
              >
                <option value="">{form.time ? "Select Status" : "Select Time first"}</option>
                {statuses.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>

            <div className={styles.field}>
              <label htmlFor="notes">Notes</label>
              <textarea
                id="notes"
                name="notes"
                value={form.notes}
                onChange={handleChange}
                placeholder={form.status ? "Additional remarks" : "Select Status first"}
                disabled={!form.status}
                rows={3}
              />
            </div>
          </div>

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.cancelBtn}
              onClick={() => setForm(getInitialForm())}
              disabled={loading}
            >
              Reset
            </button>
            <button type="submit" className={styles.submitBtn} disabled={loading}>
              {loading ? "Saving..." : "Save DCR Entry"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
